import { useEffect } from 'react';

import useMapContext from 'components/Map/hooks/useMapContext';

import useMapbox from 'hooks/useMapBox';

import type { Props } from './types';

const useSelectFeature = ({ map, onDrawingComplete, onDrawingLoaded }: Props) => {
    const { mapState } = useMapContext();
    const { drawingTool, selectedFeature } = mapState;

    const { fitToBoundsToFeature } = useMapbox();

    useEffect(() => {
        if (!selectedFeature) {
            onDrawingComplete?.();

            return;
        }

        onDrawingLoaded?.(selectedFeature);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFeature, drawingTool]);

    useEffect(() => {
        if (!selectedFeature || !map) {
            return;
        }

        fitToBoundsToFeature(map, selectedFeature);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFeature, map]);
};

export default useSelectFeature;
